export function mapInvestmentTypeToText(type) {
    if (type === 'MUTUAL_FUND') {
        return 'Mutual Funds Investments';
    }
    if (type === 'COE') {
        return 'Structured Notes';
    }
    if (type === 'FIXED_INCOME') {
        return 'Fixed Income Investments';
    }
    if (type === 'EQUITY') {
        return 'Domestic and foreign equities';
    }
    if (type === 'SECURITY') {
        return 'Private Security Investments';
    }
    if (type === 'ETF') {
        return 'Exchange-Traded Funds';
    }
    if (type === 'OTHER') {
        return 'Unknown or other investments';
    }
    return '';
}
